import { render, staticRenderFns } from "./PublicationImageItem.vue?vue&type=template&id=ca06480c&scoped=true&lang=pug"
import script from "./PublicationImageItem.vue?vue&type=script&lang=js"
export * from "./PublicationImageItem.vue?vue&type=script&lang=js"
import style0 from "./PublicationImageItem.vue?vue&type=style&index=0&id=ca06480c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca06480c",
  null
  
)

export default component.exports